// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedCalendarRouteImport } from './routes/_authenticated/calendar'
import { Route as AuthenticatedCoursesRouteImport } from './routes/_authenticated/courses'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedHolidaysRouteImport } from './routes/_authenticated/holidays'
import { Route as AuthenticatedMyScheduleRouteImport } from './routes/_authenticated/my-schedule'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedTrainersRouteImport } from './routes/_authenticated/trainers'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as AuthenticatedScheduleIndexRouteImport } from './routes/_authenticated/schedule.index'
import { Route as AuthenticatedSchedulePeriodIdRouteImport } from './routes/_authenticated/schedule.$periodId'
import { Route as OauthGoogleCalendarReturnRouteImport } from './routes/oauth.google-calendar.return'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthenticatedCalendarRoute = AuthenticatedCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCoursesRoute = AuthenticatedCoursesRouteImport.update({
            id: '/courses',path: '/courses',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHolidaysRoute = AuthenticatedHolidaysRouteImport.update({
            id: '/holidays',path: '/holidays',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMyScheduleRoute = AuthenticatedMyScheduleRouteImport.update({
            id: '/my-schedule',path: '/my-schedule',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedTrainersRoute = AuthenticatedTrainersRouteImport.update({
            id: '/trainers',path: '/trainers',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedScheduleIndexRoute = AuthenticatedScheduleIndexRouteImport.update({
            id: '/schedule/',path: '/schedule/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSchedulePeriodIdRoute = AuthenticatedSchedulePeriodIdRouteImport.update({
            id: '/schedule/$periodId',path: '/schedule/$periodId',getParentRoute: () => AuthenticatedRouteRoute
          })
const OauthGoogleCalendarReturnRoute = OauthGoogleCalendarReturnRouteImport.update({
            id: '/oauth/google-calendar/return',path: '/oauth/google-calendar/return',getParentRoute: () => rootRouteImport
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedCalendarRoute: AuthenticatedCalendarRoute,AuthenticatedCoursesRoute: AuthenticatedCoursesRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedHolidaysRoute: AuthenticatedHolidaysRoute,AuthenticatedMyScheduleRoute: AuthenticatedMyScheduleRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,AuthenticatedTrainersRoute: AuthenticatedTrainersRoute,AuthenticatedUsersRoute: AuthenticatedUsersRoute,AuthenticatedSchedulePeriodIdRoute: AuthenticatedSchedulePeriodIdRoute,AuthenticatedScheduleIndexRoute: AuthenticatedScheduleIndexRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,OauthGoogleCalendarReturnRoute: OauthGoogleCalendarReturnRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)